import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const CopyIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 9.835 12.8">
      <path
        id="Shape"
        d="M7.533,12.8H.837A.832.832,0,0,1,0,11.974V2.312a.837.837,0,0,1,.837-.835H2.462V.83A.838.838,0,0,1,3.3,0H6.546a.836.836,0,0,1,.335.072l.012.005.007,0,.012.006.012.006.038.02a1.006,1.006,0,0,1,.17.132L9.6,2.744a.831.831,0,0,1,.235.585V9.508a.816.816,0,0,1-.819.83H8.358v1.636A.817.817,0,0,1,7.533,12.8ZM.83,2.309V11.97h6.7V10.339H3.3a.838.838,0,0,1-.843-.831v-7.2ZM3.292.831V9.508H9V4.677H6a.838.838,0,0,1-.843-.83V.831ZM6,.523H6V3.846H9.3Z"
        transform="translate(0 0)"
        fill={props.color || theme.palette.gray.light}
      />
    </SvgIcon>
  );
};
